import { FC, useMemo } from 'react';

import { PersonalIdentifierType } from '@/shared/lib/sj-orm';
import { Select } from '@/shared/uikitV2/Select';
import { SelectProps } from '@/shared/uikitV2/Select/types';

import { useI18nValues } from '../hooks/useI18nValues';

type SelectPidTypesV2Props = Omit<SelectProps, 'options'> & {
  types?: PersonalIdentifierType[];
};

export const SelectPidTypesV2: FC<SelectPidTypesV2Props> = ({ types, ...props }) => {
  const i18n = useI18nValues();

  const options = useMemo(() => {
    const filtered = Array.isArray(types)
      ? pidTypeList.filter((type) => types.includes(type))
      : pidTypeList;

    return filtered.map((type) => ({
      value: type,
      content: { label: i18n.type(type) },
    }));
  }, [i18n, types]);

  const selectProps = { ...props, options } as SelectProps;

  return <Select {...selectProps} />;
};

export const pidTypeList = [
  PersonalIdentifierType.PASSPORT,
  PersonalIdentifierType.NATIONAL_ID,
  PersonalIdentifierType.RESIDENCE_PERMIT,
  PersonalIdentifierType.BIRTH_CERTIFICATE,
  PersonalIdentifierType.TAX_ID,
  PersonalIdentifierType.EDUCATION,
  PersonalIdentifierType.SOCIAL_SECURITY,
  PersonalIdentifierType.FREE_BLOCK,
  PersonalIdentifierType.MEDICAL_ID,
  PersonalIdentifierType.DRIVER_LICENSE,
  PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE,
  PersonalIdentifierType.MILITARY_ID,
  PersonalIdentifierType.SUBSTANCE,
];
